<script lang="ts">
    import MessageNotFound from './Messages/MessageNotFound.svelte';
    import { _ } from 'svelte-i18n';
    import TemplateInner from './TemplateInner.svelte';

    export let count: number;
</script>

<div class="container">
    {#if count === 0}
        <TemplateInner>
            <MessageNotFound text={$_('No items found')} />
        </TemplateInner>
    {:else}
        <MessageNotFound text={$_('Loaded_all_count_items', { values: { count: count } }).replace('{count}', count.toString())} />
    {/if}
</div>

<style>
    .container {
        width: 100%;
    }
    .end-of-loaded-items {
        text-align: center;
        opacity: 0.5;
        font-size: 13px;
    }
</style>
